module.exports = __webpack_public_path__ + "static/media/li.7787a5f8.svg";